export class ISignalRNotification {
    clientId: string;
    code: string;
    groupName?: string;
    object?: any;
}
